// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"981255fe-168":"d02d8311153daa430025","981255fe-452":"77f2bc583724edf33ff0","981255fe-379":"5e36847fb8719e65dd11","981255fe-83":"089fc207628a47ce86d4"}[chunkId] + ".js";
};